import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { API_ROOT, apiJson } from "./shared";

/**********************
 * Auth (minimal, inline)
 *********************/
const AuthContext = createContext(null);
export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(
    () => localStorage.getItem("ridley:token") || "",
  );
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (token) localStorage.setItem("ridley:token", token);
    else localStorage.removeItem("ridley:token");
  }, [token]);

  const authFetch = async (path, opts = {}) => {
    if (!API_ROOT)
      throw new Error("Set REACT_APP_API_ROOT to use auth/orders.");
    return apiJson(API_ROOT, path, {
      ...opts,
      headers: {
        ...(opts.headers || {}),
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    });
  };

  const login = async (email, password) => {
    const res = await apiJson(API_ROOT, "/users/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
    setToken(res.token);
    setUser(res.user);
    return res;
  };

  const register = async (payload) => {
    const res = await apiJson(API_ROOT, "/users/register", {
      method: "POST",
      body: JSON.stringify(payload),
    });
    setToken(res.token);
    setUser(res.user);
    return res;
  };

  const me = async () => {
    if (!token) return null;
    try {
      const u = await authFetch("/users/me");
      setUser(u);
      return u;
    } catch {
      setUser(null);
      return null;
    }
  };

  const logout = () => {
    setToken("");
    setUser(null);
  };

  useEffect(() => {
    if (API_ROOT) me(); /* eslint-disable-next-line */
  }, []);

  return (
    <AuthContext.Provider
      value={{ token, user, login, register, logout, authFetch }}
    >
      {children}
    </AuthContext.Provider>
  );
}
